import { render, staticRenderFns } from "./UserPrefs.vue?vue&type=template&id=09798aa9"
import script from "./UserPrefs.vue?vue&type=script&lang=js"
export * from "./UserPrefs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports